import { StoreStatuses } from "../enums/store/storeStatuses";
import {
  fixaTeamVirtualStores,
  fixaTeamVirtualStoreIds,
  normalizeFixaTeamStoreId,
} from "@coworker/consts/fixaTeamVirtualStores";

export {
  fixaTeamVirtualStores,
  fixaTeamVirtualStoreIds,
  normalizeFixaTeamStoreId,
};

export type Store = {
  storeId: string;
  name: string;
  status: StoreStatuses;
  locales: string[];
  primaryLocale: string;
  countryId: string;
  timezone: string;
  isVirtual: boolean;
  createdAt: Date;
  updatedAt?: Date | undefined;
  nodeType?: "STO" | "RU";
};

export const excludedStoreIds = [...fixaTeamVirtualStoreIds];
